import { useCssColors } from '@/composables/useCssColors.ts'
import { computed } from 'vue'

export function useColors() {
  const { getCssPropertyValue } = useCssColors()

  const color = (name) => {
    return getCssPropertyValue('--color-' + name)
  }

  const colorPrimary = computed(() => color('primary'))
  const colorSecondary = computed(() => color('secondary'))
  const colorSecondaryHighContrast = computed(() => color('secondary-high-contrast'))

  return {
    color,
    colorPrimary,
    colorSecondary,
    colorSecondaryHighContrast,
  }
}